import React from 'react';
import { VALIDATION_TYPES } from '../../common/validation';

const formValidationFieldList = [{ title:'excise_number', type: VALIDATION_TYPES.ZERO_ERROR  }];

const roundingOptions = [
  { value: 'round_up', title: 'Round Up' },
  { value: 'round_down', title: 'Round Down' },
  { value: 'round_to_nearest_whole_number', title: 'Round to Nearest Whole Number' },
];
const roundingDigits = [
  { value: 2, title: 2 },
  { value: 3, title: 3 },
  { value: 4, title: 4 },
];

const config = {
  formValidationFieldList,
  roundingOptions,
  roundingDigits,
};

export default config;
